export default [
  { position: 3400 },
  { position: 5350 }
];
